import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { api, environment } from "../../../environments/environment";
import { TranslocoService } from "@jsverse/transloco";
import { LoaderService } from "../../service/loader.service";
import { Message } from "../../service/message.service";
import { RestService } from "../../service/rest.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styles: [],
  standalone: false,
})
export class LoginComponent {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private translocoService: TranslocoService
  ) { }
  email: string = "";
  password: string = "";
  showPassword = false;

  manageCredentials(variableName: "email" | "password", value: any) {
    if (value?.value) {
      this[variableName] = value?.value;
    }
  }

  recoveryPassword() {
    this.router.navigate(["/recupero-password"]);
  }
  login() {
    this.loader.on();
    this.rest
      .post(api.endpoint.login, {
        email: this.email,
        password: this.password,
      })
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          this.rest.setToken(value.tokens[0].token);
          localStorage.setItem("refresh_token", value.tokens[0].refreshToken);
          localStorage.setItem("user", JSON.stringify(value));
          localStorage.setItem("roleId", value.role_id);
          if (value.completed) {
            // this.router.navigate(['bandi'])
            if (JSON.parse(localStorage.getItem('user') ?? '')?.role == 5 || JSON.parse(localStorage.getItem('user') ?? '')?.role == 1 || JSON.parse(localStorage.getItem('user') ?? '')?.role == 7 || JSON.parse(localStorage.getItem('user') ?? '')?.role == 6) {
              this.router.navigate(['profilo'])
            } else {
              if(value.planId){this.router.navigate(['profilo'])}else{
              this.router.navigate(['seleziona-piano'])}
              // this.router.navigate(['profilo'])
            }
          } else {
            this.router.navigate(['completa-profilo'])
          }
          // if (value.role_id == 2 || value.role_id == 3) {
          //   this.translocoService
          //     .selectTranslateObject("routes")
          //     .subscribe((route) => {
          //       this.router.navigate([route.userProfile.path]);
          //     });
          // } else {
          //   this.translocoService
          //     .selectTranslateObject("routes")
          //     .subscribe((route) => {
          //       this.router.navigate([route.userProfile.path]);
          //     });
          // }
        },
        error: (value: any) => {
          this.loader.off(true);
          if (environment.testing) {
            this.rest.setToken("ciao");
            // this.translocoService
            //   .selectTranslateObject("routes")
            //   .subscribe((route) => {
            //     this.router.navigate([route.userProfile.path]);
            //   });
            this.router.navigate(['progetti']);
          } else {
            this.message.showMessage(value.error.message, "error");
          }
        },
      });
  }

  registration() {
    this.router.navigate(["/registrazione"]);
  }
}
